<ng-container *ngIf="!isFreemium && !noMatchingConfig">
  <div class="container-fluid title-header-cont">
    <div class="row">
      <div class="col-md-12">
        <div class="title-header">
          <div class="title" *ngIf="!this.importedFileName">
            <div class="title-label">
              <ng-container *ngIf="!showFollowing">
                Discovery
              </ng-container>
              <ng-container *ngIf="showFollowing">
                <a class="btn btn-link close-imported-file" (click)="closeFollowing()">X</a>
                Watchlist
              </ng-container>
            </div>

            <div *ngIf="reportConfigs?.length > 0" class="btn-group toggle-filter ml-4" role="group"
              aria-label="Basic example">
              <ng-container *ngFor="let config of reportConfigs">
                <button type="button" class="btn btn-secondary"
                  [ngClass]="{'active': currentConfig?.key === config.key, 'disabled': config?.disabled}"
                  (click)="discoveryTypeClick(config)">
                  {{config.title}} <i class="fa fa-lock ml-2" *ngIf="config?.disabled"></i>
                </button>
              </ng-container>
            </div>
            <div class="triangle"></div>
          </div>
          <div class="title" *ngIf="importedFileName">
            <a class="btn btn-link close-imported-file" (click)="closeImportedFile()">X</a>
            {{this.importedFileName}}
            <div class="triangle"></div>
          </div>
          <div class="main-filters-cont {{currentConfig?.key}}" *ngIf="!showFollowing">
            <div class="top-main-filters">
              <ng-container *ngFor="let mainFilter of currentConfig?.mainFilterItems">
                <div class="main-filter mb-2" *ngIf="!mainFilter.hidden">
                  <div *ngIf="mainFilter.type === 'toggle'" class="btn-group toggle-filter insight-toggle-filter"
                    role="group" aria-label="Main Filter Selection">
                    <button type="button" class="btn btn-secondary" (click)="mainFilterOptionClick(mainFilter, option)"
                      [ngClass]="{'active': mainFilter.selected.value === option.value}"
                      *ngFor="let option of mainFilter.options" [innerHTML]="option.label"
                      [hidden]="option?.hidden"></button>
                  </div>
                  <button *ngIf="mainFilter.type === 'slider-toggle'"
                    class="btn btn-link btn-slider-toggle ml-2 position-relative"
                    [ngClass]="{ off: mainFilter.selected.value === 'F'}" (click)="mainFilterToggleClick(mainFilter)">
                    {{ mainFilter.label }}
                    <div class="d-inline-block">
                      <div class="circle-indicator"></div>
                    </div>
                  </button>
                  <div *ngIf="mainFilter.type === 'dropdown'" class="dropdown filter-dropdown">
                    <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      {{mainFilter.selected.label}}
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                      <a class="dropdown-item" (click)="mainFilterOptionClick(mainFilter, option)"
                        *ngFor="let option of mainFilter.options" [innerHTML]="option.label"
                        [hidden]="option?.hidden"></a>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
            <div class="last-update" *ngIf="!notAllowed && currentMonthLabel && !importedFileName">
              Last update as of {{currentMonthLabel}}
            </div>
            <div class="quota-remaining" *ngIf="importedFileName">
              <div class="not-found-list" *ngIf="notFoundCount > 0">
                <a class="btn btn-link not-found-count">
                  <span [innerHTML]="notFoundCount"></span> <span [innerHTML]="notFoundConfigKey"></span> not found.
                </a>
                <div class="tooltip" [innerHTML]="notFoundListHTML"></div>
                <a class="btn btn-link" target="_blank" [attr.href]="notFoundListUri">Download</a>
              </div>
              <div class="info">
                <strong>Total Quota: </strong>&nbsp;{{currentQuota | num}}&nbsp;
              </div>
              <div class="info">
                <strong>Consumed:</strong>&nbsp;{{consumedQuota | num}}&nbsp;
              </div>
              <div class="info">
                <strong>Remaining:</strong>&nbsp;{{remainingQuota | num}}&nbsp;
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="right-content discovery"
    [ngClass]="{'hide-advanced-filters' : hideAdvancedFilters, 'watchlist-view': showFollowing}" *ngIf="!notAllowed">
    <app-side-filters *ngIf="currentConfig?.mainFilterItems" [loadingData]="loadingData" [facets]="facets"
      [appGlobalSearchParam]="appGlobalSearchParam" [bulkUploadReportId]="bulkUploadReportId"
      [showFollowing]="showFollowing" [currentConfig]="currentConfig"
      [currentCannedReportUpdater]="currentCannedReportUpdater" [importedFileNameUpdater]="importedFileNameUpdater"
      [facetsUpdater]="facetsUpdater" [routeFilterValuesUpdater]="routeFilterValuesUpdater"
      [foundFiltersUpdater]="foundFiltersUpdater" [searchInputValueUpdater]="searchInputValueUpdater"
      [selectedFilterValues]="selectedFilterValues" [cannedreports]="cannedreports" [followingCount]="followingCount"
      [routeRefreshUpdater]="routeRefreshUpdater" [importStatusInvoker]="importStatusInvoker"
      [refreshDataInvoker]="refreshDataInvoker" [clearAppGlobalSearchInputInvoker]="clearAppGlobalSearchInputInvoker"
      [onDropdownFilterSelectInvoker]="onDropdownFilterSelectInvoker" [showOptionsInvoker]="showOptionsInvoker"
      [importListInvoker]="importListInvoker" (closeMobileNavClick)="toggleMobileSideNav()"
      (clearAllFiltersClick)="clearAllSelectedFilters()" [presetsListInvoker]="presetsListInvoker"
      (followingClickAction)="followingClick($event)" [prepareFiltersInvoker]="prepareFiltersInvoker">
    </app-side-filters>
    <div class="right-content-inner">
      <div class="tabbed-filters-cont"></div>
      <div class="container-fluid main-content" [ngClass]="{'loading': loading, 'loadingData': loadingData}">
        <div class="selected-filters-cont">
          <div class="filters-label">Filters:</div>
          <div class="none-label" *ngIf="!selectedFilterValues || selectedFilterValues?.length <= 0">none</div>
          <div class="selected-filter-item" *ngFor="let selected of selectedFilterValues">
            <span [innerHTML]="selected.label"></span>:&nbsp;<span [innerHTML]="selected.valueLabel"></span>
            <a class="ml-2 d-flex align-items-center" (click)="removedSelectedFilterValue(selected, event)">
              <i class="fa fa-times-circle"></i>
            </a>
          </div>
          <a [hidden]="!selectedFilterValues || selectedFilterValues?.length <=0" class="btn btn-link btn-sm clear-all"
            (click)="clearAllSelectedFilters()">Clear All</a>
        </div>
        <div class="summary-heading">
          <div class="canned-filter-title">
            <h5 class="d-flex align-items-center justify-content-sm-between">
              <span [hidden]="loading || loadingData">
                <span *ngIf="totalCount > 0">{{totalCount | num}}&nbsp;</span>
                <span *ngIf="totalCount === 0 && !showFollowing">No results found.</span>
                <span class="text-lowercase" *ngIf="totalCount > 0">
                  <ng-container *ngIf="showFollowing">following&nbsp;</ng-container>
                  <ng-container *ngIf="currentConfig?.key === 'apps'">app</ng-container>
                  <ng-container *ngIf="currentConfig?.key === 'domains'">domain</ng-container>
                  <ng-container *ngIf="currentConfig?.key === 'ctv'">app</ng-container>
                  <ng-container *ngIf="totalCount > 1">s</ng-container>
                </span>
              </span>
              <div class="loader d-inline" data-loader="circle-side"></div>
              <button class="btn btn-link mobile-filter-btn" (click)="toggleMobileSideNav()">
                <img src="/assets/images/icon-filter.svg" alt="Toggle Side Nav" />
              </button>
            </h5>
          </div>

          <div class="results-header">
            <div class="action-buttons">
              <div class="view-details" [ngClass]="{'invisible' : !(reportViewType === 'list' && totalCount > 0)}">
                <a class="" (click)="showDetails = !showDetails">
                  <i class="fa" [ngClass]="{'fa-check-square-o': showDetails, 'fa-square-o': !showDetails}"></i>
                  {{currentConfig?.viewDetailsText}}
                </a>
              </div>

              <ng-container *ngIf="!showFollowing">
                <div class="btn-group toggle-filter view-type" role="group" aria-label="Basic example">
                  <button type="button" class="btn btn-secondary" [ngClass]="{active : reportViewType === 'dashboard'}"
                    (click)="reportViewTypeClick('dashboard')">Summary
                  </button>
                  <button type="button" class="btn btn-secondary" [ngClass]="{active : reportViewType === 'list'}"
                    (click)="reportViewTypeClick('list')">List
                  </button>
                </div>

                <button class="import-csv btn btn-outline-secondary" [hidden]="showImportProgress"
                  (click)="importCSVclick()">
                  <img src="/assets/images/icon-16-download-right.svg" alt="Import CSV" />
                  CSV Import
                </button>
                <div [hidden]="!importing" class="loading-icon" data-loader="circle-side"></div>
                <input #csvFileUpload class="csvFileUpload" style="visibility:hidden;opacity:0;width:0px;height:0px;"
                  value="upload" type='file' accept='text/csv' (change)="importCSV($event)" />

                <div class="save-preset" [hidden]="savingPreset || selectedFilterValues.length <= 0">
                  <button class="btn btn-outline-secondary" (click)="showSavePresetClick()">
                    <img src="/assets/images/icon-16-add.svg" alt="Save Preset" />
                    Save as Preset
                  </button>
                  <div [hidden]="!importing" class="loading-icon" data-loader="circle-side"></div>
                </div>
              </ng-container>

              <app-discovery-download-csv [totalCount]="totalCount" [showFollowing]="showFollowing"
                [currentConfig]="currentConfig" [appGlobalSearchParam]="appGlobalSearchParam"
                [downloadButtonDisabled]="downloadButtonDisabled" [downloadColumns]="downloadColumns"
                [importedFileName]="importedFileName" [canDownloadCSV]="canDownloadCSV"
                [hideUnfilteredDownloadCsv]="hideUnfilteredDownloadCsv" [selectedFilterValues]="selectedFilterValues"
                [cannedreports]="cannedreports" [currentCannedReportUpdater]="currentCannedReportUpdater"
                [importedFileNameUpdater]="importedFileNameUpdater" [followingCount]="followingCount"
                [followIdMapping]="followIdMapping" [watchlistTypeMapping]="watchlistTypeMapping">
              </app-discovery-download-csv>
            </div>
          </div>
        </div>

        <ng-container *ngIf="totalCount > 0 && reportViewType === 'dashboard'">
          <app-app-summary-view [currentConfig]="currentConfig" [facets]="facets" [filterStrings]="filterStrings"
            [loadingData]="loadingData">
          </app-app-summary-view>
        </ng-container>

        <ng-container *ngIf="reportViewType === 'list' && !(showFollowing && gridData.length <=0)">
          <app-app-list-view [reportViewType]="reportViewType" [showFollowing]="showFollowing"
            [currentConfig]="currentConfig" [showDetails]="showDetails" [gridData]="gridData"
            [showLoadMore]="showLoadMore" [showLoadingMore]="showLoadingMore"
            [appGlobalSearchParamModel]="appGlobalSearchParamModel" [isFreemium]="isFreemium"
            [notificationSettings]="notificationSettings" (loadMoreClick)="loadMore()"
            (unfollowItem)="unfollowItem($event)" (toggleSortClick)="toggleSort($event)"
            (appGlobalSearch)="appGlobalSearch($event)" (clearAppGlobalSearch)="clearAppGlobalSearch()">
          </app-app-list-view>
        </ng-container>

        <ng-container *ngIf="showFollowing && gridData.length <= 0 && !loadingData">
          <app-no-following [currentConfig]="currentConfig" (closeFollowingClick)="closeFollowing()"></app-no-following>
        </ng-container>

      </div>
    </div>
  </div>
  <div class="aa-app-data-notice" *ngIf="showUploadSuccess">
    <div class="aa-paywall-section uploadSuccess">
      <a class="close pull-xl-right" (click)="showUploadSuccess = false; uploadingCsv = false;">
        <i class="fa fa-close"></i>
      </a>
      <p class="header mb-1">CSV import was successful and has been queued for processing.</p>
      <p class="mb-2">Once the results are generated we will send an email to the email address associated with this
        account.</p>
      <div class="button-bar">
        <button class="btn btn-lg btn-primary" (click)="showUploadSuccess = false; uploadingCsv = false;"
          (keydown)="showUploadSuccess = false; uploadingCsv = false;" autofocus>
          OK
        </button>
      </div>
    </div>
  </div>
  <div class="aa-app-data-notice" *ngIf="showServerError">
    <div class="aa-paywall-section">
      <a class="close pull-xl-right" (click)="showServerError = false; uploadingCsv = false;">
        <i class="fa fa-close"></i>
      </a>
      <p class="header mb-1">Importing operation failed.</p>
      <p *ngIf="errorMessage != ''" class="m-b-1">{{errorMessage}}</p>
      <p class="mb-2"> Contact support@pixalate.com.</p>
      <div class="button-bar">
        <button class="btn btn-lg btn-primary" (click)="showServerError = false; uploadingCsv = false;"
          (keydown)="showServerError = false; uploadingCsv = false;" autofocus>
          OK
        </button>
      </div>
    </div>
  </div>
  <div class="aa-app-data-notice" *ngIf="showQuotaExceeded">
    <div class="aa-paywall-section quotaMessageCont">
      <a class="close pull-xl-right" (click)="showQuotaExceeded = false; uploadingCsv = false;">
        <i class="fa fa-close"></i>
      </a>
      <p class="header mb-1" *ngIf="quotaCount && quotaStartDate && quotaEndDate">
        Quota({{quotaCount}}) exceeded for the duration {{quotaStartDate}} to {{quotaEndDate}}.</p>
      <p class="mb-2">Please contact your sales representative for more details.</p>
      <div class="button-bar">
        <button class="btn btn-lg btn-primary" (click)="contact()"
          (keydown)="showQuotaExceeded = false; uploadingCsv = false;" autofocus>Contact Sales</button>
      </div>
    </div>
  </div>
  <div class="import-status" *ngIf="showImportProgress">
  </div>
  <div class="label-import-status" *ngIf="showImportProgress">
    <div *ngIf="!importErrorMessage">
      <i class="fa fa-spin fa-spinner ml-2"></i><br />
      Loading data...<br />Please wait on this page, or save the URL,<br />and check back in approximately 3-30
      minutes.<br />This URL will be valid for 7 days.

    </div>
    <div *ngIf="importErrorMessage">
      {{importErrorMessage}}
      <div>
        <a class="btn btn-link" (click)="goBackToDiscovery()">{{importErrorButtonText}}</a>
      </div>
    </div>
  </div>
  <div class="aa-app-data-notice save-preset" *ngIf="showSavePreset">
    <div class="aa-paywall-section quotaMessageCont">
      <a class="close pull-xl-right" (click)="showSavePreset = false;">
        <i class="fa fa-close"></i>
      </a>
      <p class="header mb-1">Title</p>
      <p class="mb-2">
        <input type="text" class="form-control" [(ngModel)]="savedPresetTitle" (keydown.enter)="savePreset()" />
      </p>
      <div class="button-bar">
        <button class="btn btn-lg btn-primary" (click)="savePreset()">Save as Preset</button>
      </div>
    </div>
  </div>
  <div class="aa-app-data-notice import-filter" *ngIf="showImportParam">
    <div class="aa-paywall-section">
      <a class="close pull-xl-right" (click)="showImportParam = false;">
        <i class="fa fa-close"></i>
      </a>
      <p class="header mb-1">Import Filter for {{ currentConfig.title }}</p>
      <div class="d-flex flex-row justify-content-between mt-5">
        <div class="d-flex flex-column" *ngFor="let group of currentConfig.importParams">
          <span class="group-title font-weight-bold mb-1">{{ group.label }}</span>
          <ng-container *ngIf="group.type === 'checkbox'">
            <p class="group-option form-check" *ngFor="let option of group.options">
              <label class="form-check-label">
                <input type="checkbox" class="form-check-input mr-2"
                  [checked]="selectedImportParams[currentConfig.key][group.key] | arrayContainsValue:option.value"
                  (change)="updateImportParam(currentConfig, group, option, $event.target.checked)" />
                {{ option.label }}
              </label>
            </p>
          </ng-container>
          <ng-container *ngIf="group.type === 'radio'">
            <p class="group-option form-check" *ngFor="let option of group.options">
              <label class="form-check-label">
                <input type="radio" class="form-check-input" name="optionsRadios" id="{{ 'option' + option.label }}"
                  [checked]="selectedImportParams[currentConfig.key][group.key] | arrayContainsValue:option.value"
                  (click)="updateImportParam(currentConfig, group, option)">
                {{ option.label }}
              </label>
            </p>
          </ng-container>
        </div>
      </div>

      <div class="remove-duplicates" *ngIf="currentConfig.key == 'ctv'">
        <label class="form-check-label">
          <input type="checkbox" class="form-check-input mr-2" [(ngModel)]="importCsvRemoveDuplicates" />
          Remove Duplicates
        </label>
      </div>

      <div class="d-flex align-items-center mt-5">
        <a class="btn btn-link mr-auto" (click)="showImportParam = false">Cancel</a>
        <button class="btn btn-secondary mr-2" (click)="toggleImportOptions(false)">Deselect All</button>
        <button class="btn btn-primary" (click)="proceedWithImport()">Proceed
          with Import</button>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isFreemium || noMatchingConfig">
  <div class="container discovery-freemium-container">
    <div class='row'>
      <div class='col'>
        <h3 class='mt-5 mb-3'>Discovery</h3>
      </div>
    </div>
    <div class='row'>
      <div class='col-lg'>
        <p class='body-text'>Building a high quality, low fraud platform across inventory sources is challenging. Our
          Discovery tool helps you build your inclusion and exclusion lists with the ability to filter across 500
          metrics, like app details, traffic and brand safely. These exclusive Mobile App, Domain and CTV insights are
          useful to craft a scaled platform that meets your marketing needs.
        </p>
        <button class='btn btn-primary btn-schedule-a-demo' (click)='_eventService.openScheduleADemo()'>Schedule a
          Demo!</button>
      </div>
      <div class='col-lg text-center'>
        <img src='/assets/images/discovery-preview.png' style='max-height:300px' alt="Discovery Preview" />
      </div>
    </div>
    <div class='row mt-100px'>
      <div class='col-lg'>
        <h4 class='mb-3'>
          Media Ratings Terminal By the Numbers
        </h4>
        <p class='body-text'>Pixalate’s Discovery brings you unique, granular Mobile App, Domains and CTV ratings. We
          bring together 3rd party sources, such as app store profiles or registration data, along with Pixalate
          analytics, like IVT levels and share of voice to give you supply quality ratings for secure platform growth.
        </p>
        <button class='btn btn-primary btn-schedule-a-demo' (click)='_eventService.openScheduleADemo()'>Schedule a
          Demo!</button>
      </div>
      <div class='col-lg'>
        <div class='feature-grid'>
          <div class='feature-cell'>
            <div class='feature-icon'>
              <i class='fa fa-mobile'></i>
            </div>
            <div class='feature-text'>
              <div class='feature-text-head'>5M+</div>
              <div class='feature-text-body'>Number of Mobile<br />Apps Monitored</div>
            </div>
          </div>
          <div class='feature-cell'>
            <div class='feature-icon'>
              <i class='fa fa-globe'></i>
            </div>
            <div class='feature-text'>
              <div class='feature-text-head'>550K+</div>
              <div class='feature-text-body'>Number of Domains<br />Monitored</div>
            </div>
          </div>
          <div class='feature-cell'>
            <div class='feature-icon'>
              <i class='fa fa-tv'></i>
            </div>
            <div class='feature-text'>
              <div class='feature-text-head'>40K+</div>
              <div class='feature-text-body'>Number of CTV Apps<br />Monitored</div>
            </div>
          </div>
          <div class='feature-cell'>
            <div class='feature-icon'>
              <i class='fa fa-bar-chart'></i>
            </div>
            <div class='feature-text'>
              <div class='feature-text-head'>500+</div>
              <div class='feature-text-body'>Number of Metrics<br />Monitored</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class='row mt-100px'>
      <div class='col'>
        <h4 class='mb-3'>
          Filter across 500 metrics
        </h4>
      </div>
    </div>
    <div class='row mb-5'>
      <div class='col-lg-7'>
        <p class='body-text'>
          Our comprehensive set of data points and filters allow you to create the insights you need, including:
        </p>
      </div>
    </div>
    <div class='row mb-5'>
      <div class='col-lg-4'>
        <div class='large-icon-badge'>
          <i class='fa fa-mobile'></i>
        </div>
      </div>
      <div class='col-lg-8'>
        <h5>
          Mobile Apps
        </h5>
        <div class='row'>
          <div class='col-md'>
            <h6>Google Play</h6>
            <p>
              App Details, Adult Content, Violence Content, High IVT, No Privacy Policy, No Ads, AOnymous (Private
              Domain), Play Store Categories, IAB Categories, Risk, Permission Risk, COPPA Violation Risk, Ad Fraud
              Risk, Brand Safety Risk, Content Brand Safety Rating, Marketing Compliance Risk, Developer Details, Ad
              Capabilities, App Performance,
              Reach, Trusted Seller, Viewabiltiy(%) and more...
            </p>
          </div>
          <div class='col-md'>
            <h6>Apple App Store</h6>
            <p>
              App Details, Adult Content, Violence Content, High IVT, No Privacy Policy, No Ads, AOnymous (Private
              Domain), App Store Categories, IAB Categories, Risk, COPPA Violation Risk, Ad Fraud Risk, Brand Safety
              Risk, Content Brand Safety Rating, Marketing Compliance Risk, Developer Details, Ad Capabilities, App
              Performance, Reach, Trusted
              Seller, Viewabiltiy(%) and more...
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class='row mb-5'>
      <div class='col-lg-4'>
        <div class='large-icon-badge'>
          <i class='fa fa-globe'></i>
        </div>
      </div>
      <div class='col-lg-8'>
        <h5>
          Domains
        </h5>

        <p>
          Domain Details, IAB Categories, Risk, IVT%, Publisher Details, Ad Capabilities, CTR, Bid Range, Day of the
          Week, Device, Geo, Privacy Policy, Terms and Conditions, Trusted Seller, Top Level Domain, Top Traffic, Source
          Traffic, Viewability and more...
        </p>
      </div>
    </div>
    <div class='row mb-5'>
      <div class='col-lg-4'>
        <div class='large-icon-badge'>
          <i class='fa fa-tv'></i>
        </div>
      </div>
      <div class='col-lg-8'>
        <h5>
          Connected TV
        </h5>
        <div class='row'>
          <div class='col-md'>
            <h6>Roku</h6>
            <p>
              App Age, Roku Store Categories, Risk, App Age Risk, SSAI%, Transparent SSAI%, Ad Fraud Risk, Brand Safety
              Risk, Brand Safety Content Risk, Marketing Compliance Risk, Developer Details, Ads Detected, App Age,
              Keywords, Parental Hint, Revenue Sources, CVAA Compliant, Trusted Seller, Ad Capabilities, Channels, Geo,
              Reach and more…
            </p>
            <button class='btn btn-primary btn-schedule-a-demo' (click)='_eventService.openScheduleADemo()'>Schedule a
              Demo!</button>
          </div>
          <div class='col-md'>
            <h6>Fire TV</h6>
            <p>
              App Age, Fire TV Store Categories, Risk, App Age Risk, SSAI%, Transparent SSAI%, Ad Fraud Risk, Brand
              Safety Risk, Brand Safety Content Risk, Marketing Compliance Risk, Developer Details, Ads Detected, App
              Age, Keywords, Parental Hint, Revenue Sources, CVAA Compliant, Trusted Seller, Ad Capabilities, Channels,
              Reach and more…
            </p>
          </div>
          <div class='col-md'>
            <h6>Samsung</h6>
            <p>
              App Age, Samsung Store Categories, Risk, App Age Risk, SSAI%, Transparent SSAI%, Ad Fraud Risk, Brand
              Safety Risk, Brand Safety Content Risk, Marketing Compliance Risk, Developer Details, Ads Detected, App
              Age, Keywords, Parental Hint, Revenue Sources, CVAA Compliant, Trusted Seller, Ad Capabilities, Channels,
              Reach and more…
            </p>
          </div>
          <div class='col-md'>
            <h6>tvOS</h6>
            <p>
              App Age, tvOS Store Categories, Risk, App Age Risk, SSAI%, Transparent SSAI%, Ad Fraud Risk, Brand
              Safety Risk, Brand Safety Content Risk, Marketing Compliance Risk, Developer Details, Ads Detected, App
              Age, Keywords, Parental Hint, Revenue Sources, CVAA Compliant, Trusted Seller, Ad Capabilities, Channels,
              Reach and more…
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class='row mt-100px'>
      <div class="col-lg">
        <h5>Customize Your Lists</h5>
        <p class='body-text'>
          Pixalate’s Discovery has multiple presets to help you get started. You also have the ability to create custom
          filters based on our 500 metrics and save those as your own presets, as well as import CSV from existing
          inventory sources to match and see your risk factors. You can also download your created list in a CSV format.
        </p>

        <button class='btn btn-primary btn-schedule-a-demo' (click)='_eventService.openScheduleADemo()'>Schedule a
          Demo!</button>
      </div>
      <div class="col-lg text-center">
        <img src='/assets/images/discovery-presets.png' alt="Discovery Presets" />
      </div>
    </div>
  </div>
</ng-container>